import { GET_ACCESS_TOKEN, PUBLIC_API_URL } from '../constants/api';
import CookieService from '../services/app/cookie.service';
import StorageService from '../services/app/storage.service';
import { decryptData } from './crypto';

// check access token is expired or not
export const checkAccessToken = async (isAdmin = true) => {
    if (isAccessTokenExpired(isAdmin)) {
        try {
            //   await checkRefreshAccessToken();

            return false;
            // return true;
        } catch (e) {
            let error = e ? false : true;
            return error;
        }
    }

    return true;
};

export const isAccessTokenExpired = (isAdmin = true) => {
    if (isAdmin) {
        const token = CookieService.get('token');

        if (token) {
            return false;
        }
    } else {
        const token = CookieService.get('subscriber_token');

        if (token) {
            return false;
        }
    }

    return true;
};

export const checkRefreshAccessToken = async () => {
    if (isRefreshTokenExpired()) {
        throw new Error('Refresh token is expired');
    }

    const refresh_token = CookieService.get('refresh_token');

    try {
        const response = await fetch(PUBLIC_API_URL + GET_ACCESS_TOKEN, {
            method: 'POST',
            headers: refreshHeader(),
            body: JSON.stringify({ refresh_token: refresh_token }),
        });

        if (!response.ok) {
            // StorageService.clear()
            // CookieService.clear()

            throw new Error('Unable to generate access token!');
        }

        const data = await response.json();

        if (data) {
            const user = decryptData(StorageService.get('user'));

            // Update the values
            if (user) {
                user.token = data.data.token; // Update token
                user.expires_at = data.data.expires_at; // Update expires-at
                StorageService.set('user', encryptData(user));
                CookieService.set('token', data.data.token, ACCESS_TOKEN_DURATION);
            }
        }

        return data; // Return new data for further use if needed
    } catch (error) {
        throw new Error(error.message); // Throw error for handling in components
    }
};

export const isLoggedIn = () => {
    const token = CookieService.get('token');
    const user = StorageService.get('user');

    return !!token && !!user; // true if both exist
};

export const getCurrentUser = () => {
    const user = StorageService.get('user');
    return user ? decryptData(user) : null;
};

export const logout = () => {
    StorageService.clear();
    CookieService.clear();

    // Optional: Redirect or trigger UI update
    window.location.replace('/'); // or use a router if you're using React Router
};
